/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RallyChampionRequestBody
 */
export interface RallyChampionRequestBody {
    /**
     * 
     * @type {number}
     * @memberof RallyChampionRequestBody
     */
    position: number;
    /**
     * 
     * @type {number}
     * @memberof RallyChampionRequestBody
     */
    track_played: number;
}

export function RallyChampionRequestBodyFromJSON(json: any): RallyChampionRequestBody {
    return RallyChampionRequestBodyFromJSONTyped(json, false);
}

export function RallyChampionRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RallyChampionRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'position': json['position'],
        'track_played': json['track_played'],
    };
}

export function RallyChampionRequestBodyToJSON(value?: RallyChampionRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'position': value.position,
        'track_played': value.track_played,
    };
}


